import { useMutation, useQueryClient } from "react-query";
import { crearDocuGeneral, updateDocuGeneral, deleteDocuGeneral} from '../../services/DocumentosGenerales';
import { toast } from 'react-hot-toast';

const queryKey = "documentosgenerales";

export const useDocumentosGeneralesMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
    toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };
  const addDocuGeneral = useMutation((body) => crearDocuGeneral(body), {
    onSuccess,
    onError: (err) => onError(err),
  });
 
  const updateDocuGeneralC = useMutation(
    (body) => updateDocuGeneral( body),
    {
      onSuccess,
      onError: (err) => onError(err),
    }
  );
  const removeDocuGeneral = useMutation((id) => deleteDocuGeneral( id), {
    onSuccess,
    onError,
  });

  return { addDocuGeneral, updateDocuGeneralC, removeDocuGeneral };
};
export default useDocumentosGeneralesMutations;